import { GooglePlacesApiState } from './types/GooglePlacesApiState';

export const initialGooglePlacesApiState: GooglePlacesApiState = {
  suggestedPlacesList: [],
  selectedPlaceDetails: null,
  statuses: {
    isSuggestedPlacesListLoading: false,
  },
};
